/*
 * ヘッダードロワーの子階層をインライン・アコーディオンとして開閉する。
 * <header-drawer> の capture フェーズで子サマリのクリックを横取りし、Dawn のスライド処理を止めて
 * grid-rows アニメ用の open / .menu-opening を管理する（原本 global.js は非改変）。
 * あわせて最大高さの上下余白（ヘッダー高）を CSS 変数 --menu-drawer-space に設定する。
 */
(function () {
  // ドロワー上端（ヘッダー下端）位置を最大高さの上下余白として共有する。
  // Dawn の --header-bottom-position は透過ヘッダーの .section-header が 0 高のため使えず、
  // 実ヘッダー .header-wrapper を計測する。値が効くのはドロワー開時のみなので開くタイミングで更新する。
  function setDrawerSpace() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    document.documentElement.style.setProperty(
      '--menu-drawer-space',
      Math.round(header.getBoundingClientRect().bottom) + 'px'
    );
  }

  document.querySelectorAll('header-drawer').forEach(function (drawer) {
    drawer.addEventListener(
      'click',
      function (event) {
        var summary = event.target.closest('summary');
        if (!summary || !drawer.contains(summary)) return;

        var details = summary.parentElement;
        if (!details || details.tagName !== 'DETAILS') return;

        // 子階層（submenu を直下に持つ details）のみ対象。メインドロワーは Dawn に委譲
        var submenu = details.querySelector(':scope > .menu-drawer__submenu');
        if (!submenu) {
          setDrawerSpace();
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        if (details.hasAttribute('open')) {
          // 閉じ: .menu-opening を外して高さを 0 へアニメーションし、完了後に open を除去
          details.classList.remove('menu-opening');
          summary.setAttribute('aria-expanded', 'false');
          window.setTimeout(function () {
            details.removeAttribute('open');
          }, 320);
        } else {
          // 開き: open を付与し、reflow を挟んで .menu-opening を付け 0fr→1fr をアニメーション
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
          void submenu.offsetHeight;
          details.classList.add('menu-opening');
        }
      },
      true
    );
  });
})();
